// Thin wrapper around the browser reload so callers can be unit-tested.
// jsdom defines `location` (and `location.reload`) as non-configurable, which
// makes it impossible to spy on directly; mocking this module instead is clean.
const reloadPage = (): void => {
  globalThis.location.reload();
};

export default reloadPage;
